
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/en/home",
      function () {
        return require("private-next-pages/fr/en/home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/en/home"])
      });
    }
  